import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
// img
import TelegramGuideImg from '@assets/images/guide/telegram-guide-img.jpg'
// icon
// css
import {
  ContentWrap,
  Content,
} from '@styles/base.style'

const TelegramGuide: React.FC = props => {
  let contentWarpStyle
  if (!isMobile) {
    contentWarpStyle = { overflow: 'auto' }
  }

  return (
    <Fragment>
      <ContentWrap style={contentWarpStyle} className="telegram-guide-wrap">
        <Content>
          <img src={TelegramGuideImg} alt="텔레그램 연동 가이드 이미지" style={{ width: '100%', marginTop: 20 }}/>
        </Content>
      </ContentWrap>
    </Fragment>
  )
}

export default observer(TelegramGuide)
